import { render, staticRenderFns } from "./video-slider.vue?vue&type=template&id=deffea2e&scoped=true&"
import script from "./video-slider.vue?vue&type=script&lang=js&"
export * from "./video-slider.vue?vue&type=script&lang=js&"
import style0 from "./video-slider.vue?vue&type=style&index=0&id=deffea2e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deffea2e",
  null
  
)

export default component.exports